'use strict';

// import Swiper bundle with all modules installed
import Swiper from 'swiper';
import {A11y, Autoplay, EffectFade, Keyboard, Navigation, Pagination} from 'swiper/modules';

//import "accordionjs/accordion.min";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        //self.cloneMainMenu();
        //self.fancybox();
        //self.accordion();
        self.swiperHeroInit();
        //self.carouselInit();

    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("click", function () {
            self.mobileMenu();
        });

        $("#js-open-search").on("click", function(){
            var isOpen = $("#js-searchbar").toggleClass("searchbar--open").hasClass("searchbar--open");
            $(this).attr("aria-expanded", isOpen);
            if ( isOpen ) {
                setTimeout(function() {
                    $("#js-search-text").focus();
                }, 300 );
            }
        });

        $("#js-searchbar-bg").on("click", function(){
            self.closeSearch();
        });

        self.$document.keydown(function (e) {
            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                if ( $("#js-searchbar").hasClass("searchbar--open") ) {
                    self.closeSearch();
                    $("#js-open-search").focus();
                }
                if ( self.$mobileMenu.hasClass("mobile-menu--open") ) {
                    self.mobileMenu();
                }
            }

            if ( self.$mobileMenu.hasClass("mobile-menu--open") ) {
                self.trapFocus( e, self.$mobileMenu );
            }
            else if ( $("#js-searchbar").hasClass("searchbar--open") ) {
                self.trapFocus( e, $("#js-searchbar") );
            }
        });

        $(".more-info-btn").on("click", function(e) {
            $("#more-info").toggleClass("open");
            $(this).toggleClass("btn-icon--arr-expand btn-icon--arr-expand-less");
            e.preventDefault();
        });

        $(".js-mobile-submenu-open").on( "click", function() {
            var isOpen = $(this).toggleClass("_opened").hasClass("_opened");
            $(this).attr("aria-expanded", isOpen)
                .closest("li").find("> ul").slideToggle( 300 );
        } );

    },

    closeSearch: function(){

        $("#js-searchbar").removeClass("searchbar--open");
        $("#js-open-search").attr("aria-expanded", false);

    },

    // Keeps Tab inside an open overlay, so the keyboard does not wander
    // into the page hidden behind it
    // WCAG 2.1 A, 2.4.3 Focus Order
    trapFocus: function ( e, $container ) {

        if ( e.key !== "Tab" && e.keyCode !== 9 ) {
            return;
        }

        var $focusable = $container
                .find("a[href], button:not(:disabled), input:not(:disabled), select, textarea, [tabindex]:not([tabindex='-1'])")
                .filter(":visible"),
            first = $focusable.first()[0],
            last = $focusable.last()[0];

        if ( !first ) {
            return;
        }

        if ( !$.contains( $container[0], document.activeElement ) ) {
            e.preventDefault();
            first.focus();
        }
        else if ( e.shiftKey && document.activeElement === first ) {
            e.preventDefault();
            last.focus();
        }
        else if ( !e.shiftKey && document.activeElement === last ) {
            e.preventDefault();
            first.focus();
        }

    },

    accordion: function(){

        $(".accordion").accordionjs({
            // Allow self close.(data-close-able)
            closeAble   : true,
            // Close other sections.(data-close-other)
            closeOther  : false,
            // Animation Speed.(data-slide-speed)
            slideSpeed  : 300,
            // The section open on first init. A number from 1 to X or false.(data-active-index)
            activeIndex : false,
            // Callback when a section is open
            //openSection: function( section ){},
            // Callback before a section is open
            //beforeOpenSection: function( section ){},
        });

        // Otevirame podle hashe v URL adrese
        var hash = new URL(document.URL).hash;

        if ( hash && $(".accordionjs").length > 0 ) {
            $(hash).addClass( "acc_active" ).find(".acc_content").show();
            $("html, body").animate({
                scrollTop: $(hash).offset().top - 100 // offset
            }, 150);
        }

    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("mobile-menu--open") ){
            self.$mobileMenu.removeClass("mobile-menu--open");
            $hamburger.attr("aria-expanded", false);
            $(".header__hamburger").focus();
            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$mobileMenu.addClass("mobile-menu--open");
            $hamburger.attr("aria-expanded", true);
            $(".mobile-menu__hamburger").focus();
            t = setTimeout( function(){
                $hamburger.addClass("is-active");
            }, 200 );
        }

    },

    cloneMainMenu: function(){

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        //if( self.$document.scrollTop() > self.$header.outerHeight() ) {
        if( self.$document.scrollTop() > 0 ) {
            self.$body.addClass('js-scrolling');
        }
        else {
            self.$body.removeClass('js-scrolling');
        }
/*
        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }
*/
    },

    fancybox: function() {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });
    },

    swiperHeroInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-swiper-hero', {
            modules: [
                A11y,
                Autoplay,
                EffectFade,
                Navigation,
                Pagination,
                Keyboard
            ],
            loop: true,
            speed: 900,
            // Users asking for reduced motion must not get a moving slider on load
            // WCAG 2.1 AAA, 2.3.3 Animation from Interactions
            autoplay: self.prefersReducedMotion() ? false : {
                delay: 5000,
                disableOnInteraction: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            // Without this module the navigation arrows are plain divs:
            // no role, no tab stop, no accessible name
            // WCAG 2.1 A, 2.1.1 Keyboard + 4.1.2 Name, Role, Value
            a11y: {
                enabled: true,
                containerMessage: 'Fotografie školy',
                prevSlideMessage: 'Předchozí fotografie',
                nextSlideMessage: 'Další fotografie',
                firstSlideMessage: 'První fotografie',
                lastSlideMessage: 'Poslední fotografie',
                slideLabelMessage: 'Fotografie {{index}} z {{slidesLength}}'
            },
            preloadImages: true,
            //lazyLoading: true,
            //lazy: {
            //    loadPrevNext: true,
            //},
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }
            */
        });

        self.heroAutoplayToggle();
    },

    // Manual stop for the auto-rotating hero
    // WCAG 2.1 A, 2.2.2 Pause, Stop, Hide
    heroAutoplayToggle: function() {

        var self = this,
            $button = $("#js-hero-autoplay"),
            autoplay = self.swiperHero && self.swiperHero.autoplay;

        if ( !$button.length || !autoplay ) {
            return;
        }

        // Nothing rotates with reduced motion, so a stop control would be a dead button
        if ( !self.swiperHero.params.autoplay || !self.swiperHero.params.autoplay.enabled ) {
            $button.remove();
            return;
        }

        function render( isRunning ) {
            $button
                .toggleClass("is-paused", !isRunning)
                .find(".js-hero-autoplay-label")
                .text( isRunning ? "Pozastavit automatické přehrávání" : "Spustit automatické přehrávání" );
        }

        $button.on("click", function(){
            if ( self.swiperHero.autoplay.running ) {
                self.swiperHero.autoplay.stop();
            }
            else {
                self.swiperHero.autoplay.start();
            }
        });

        // Swiper stops autoplay on its own because of disableOnInteraction
        self.swiperHero.on("autoplayStop", function(){ render( false ); });
        self.swiperHero.on("autoplayStart", function(){ render( true ); });

        render( autoplay.running );
    },

    prefersReducedMotion: function() {

        return window.matchMedia
            && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    },

    carouselInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-carousel', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true
            },
            //effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            navigation: {
                nextEl: '.carousel-nav--next',
                prevEl: '.carousel-nav--prev'
            },
            on: {
                transitionEnd: function() {
                    // vanilla lazyload
                    lazyLoadInstance.update();
                }
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                // when window width is >= 420px
                420: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        });
    }
};

$(document).ready(function () {
    new J3WTheme();
});

// Tohle tady mame kvuli fancyboxu
// Kdyz to tu neni, fancybox hlasi chybu
// Netusim proc (novy fancybox by to vyresil, ale je placenej)
window.jQuery = window.$ = $;
